export const waterMark = {
    marketplace: '/assets/images/watermark-marketplace.svg',
    realState: '/assets/images/watermark-imobiliaria.svg'
}

export const realStateCategoryId = '0a15f51e-8dab-4038-94ac-84d72154cea3';